function isIndexSegment(segment) {
    return !!segment && /^[0-9]+$/.test(segment);
}
function getComposedListBasePath(targetFieldPath) {
    const parts = targetFieldPath.split(".");
    const leafKey = parts.pop() || "";
    const parentParts = parts;
    if (isIndexSegment(parentParts[parentParts.length - 1])) {
        parentParts.pop();
        return { basePath: parentParts.join("."), leafKey };
    }
    return { basePath: null, leafKey };
}
/**
 * Utility for transforms: ensures proposedValue is unique among sibling items of the same composedList group
 * for the same leafKey.
 *
 * Example: for targetFieldPath `fields.1.key`, ensure uniqueness among `fields.<i>.key`.
 */
export function makeUniqueWithinComposedListGroup(targetFieldPath, proposedValue, renderViewMap) {
    if (!proposedValue)
        return proposedValue;
    const { basePath, leafKey } = getComposedListBasePath(targetFieldPath);
    if (!basePath)
        return proposedValue;
    const baseParts = basePath ? basePath.split(".") : [];
    const used = new Set();
    for (const field of Object.values(renderViewMap)) {
        if (!field?.fieldPath || field.fieldPath === targetFieldPath)
            continue;
        const parts = field.fieldPath.split(".");
        if (parts.length !== baseParts.length + 2)
            continue;
        if (parts[parts.length - 1] !== leafKey)
            continue;
        if (parts.slice(0, baseParts.length).join(".") !== basePath)
            continue;
        if (!isIndexSegment(parts[baseParts.length]))
            continue;
        const v = field.value;
        if (typeof v === "string" && v)
            used.add(v);
    }
    if (!used.has(proposedValue))
        return proposedValue;
    let suffix = 2;
    while (used.has(`${proposedValue}${suffix}`))
        suffix++;
    return `${proposedValue}${suffix}`;
}
/**
 * Applies default bindings for fields that depend on `changingField`.
 *
 * - Only applies when the target field is currently null/undefined (never overwrites user-entered values)
 * - Only applies for sibling fields (same parent group)
 * - Transform functions receive `(changingField, ctx, targetField)` and can use ctx for additional logic
 */
export function applyDefaultBindings(ctx, changingField, transformRegistry) {
    const values = ctx.getRenderViewMap();
    Object.values(values).forEach((targetField) => {
        //if (targetField.value !== null && targetField.value !== undefined) return;
        if (!changingField.firstSession)
            return;
        if (targetField.fieldPath === changingField.fieldPath)
            return;
        const targetConfig = ctx.getConfig(targetField.configName);
        const bindingConfig = targetConfig?.defaultBinding;
        if (bindingConfig && bindingConfig.field === changingField.key && ctx.areSiblings(targetField, changingField)) {
            const transformFn = bindingConfig.transform ? transformRegistry[bindingConfig.transform] : undefined;
            const nextValue = transformFn ? transformFn(changingField, ctx, targetField) : changingField.value;
            ctx.setValue(targetField.fieldPath, nextValue);
        }
    });
}
